const adjustFooterMargin = () => {
    const footer = document.querySelector("footer");
    if (!footer) return;

    if (document.getElementById("article-page")) {
        footer.style.marginTop = "0px";
        return;
    }

    // Select all potential last content blocks (divs, sections) inside .section-grid
    const contentBlocks = document.querySelectorAll(".section-grid > div, .section-grid > section , .section-grid > section > div , .section-grid > section > section, .section-grid > section > div > div , .section-grid > section > section > div, .section-grid > section > section > section , .section-grid > section > div > section");
    if (contentBlocks.length === 0) return;

    // Find the last visible content block
    let lastContent = null;
    for (let i = contentBlocks.length - 1; i >= 0; i--) {
        if (contentBlocks[i].offsetHeight > 0) {
            lastContent = contentBlocks[i];
            break;
        }
    }
    if (!lastContent) return;
    const hasTwoColumnBanner = lastContent.getAttribute("data-type") === "two-column-banner";
    let lastElementBottom = lastContent.getBoundingClientRect().bottom;
    let paddingBottom = parseFloat(getComputedStyle(lastContent).paddingBottom) || 0;

    if (lastContent.dataset?.label === 'sponsor') {
        footer.style.marginTop = "0px";
        return;
    }

    // **Calculate space between last content and footer**
    const footerRect = footer.getBoundingClientRect();
    let spaceAboveFooter = footerRect.top - lastElementBottom;

    // Prevent negative values
    if (spaceAboveFooter < 0) spaceAboveFooter = 0;

    // **Calculate required footer margin to make padding + margin = 120px**
    let requiredMarginTop = hasTwoColumnBanner ? 120 : 120 - paddingBottom;

    if (requiredMarginTop < 0) requiredMarginTop = 0;

    // Apply the calculated margin
    footer.style.marginTop = `${requiredMarginTop}px`;
};
// Run on load, resize, and mutations (for real-time updates)
document.addEventListener("DOMContentLoaded", adjustFooterMargin);

// **Observer to detect DOM changes**
const footerObserver = new MutationObserver(adjustFooterMargin);
footerObserver.observe(document.body, { childList: true, subtree: true });
